module.exports = __webpack_public_path__ + "img/aggregate-follow.e7807859.jpg";